import { clearedFilters } from '../../shared/products';

export default {
    namespaced: true,
    state: {
        filters: {},
    },
    mutations: {
        setFilters(state, { pageKey, filters }) {
            const dict = { ...state.filters };
            dict[pageKey] = filters;
            state.filters = dict;
        },
    },
    getters: {
        getFilters: (state) => (pageKey) => {
            return state.filters[pageKey] || { ...clearedFilters };
        },
    },
};
